module.exports = __webpack_public_path__ + "img/dfsz.4c866fe7.jpg";